import styled from 'styled-components'
import {
	media,
	Breakpoints,
	themeObject,
	textModels,
	mediaOnly,
} from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled.div`
	padding: 32px;
	border-radius: 16px;
	background-color: ${themeObject.colors.base.white};
	box-sizing: border-box;
	&:nth-child(1),
	&:nth-child(2) {
		grid-row: 1;
		${mediaOnly('grid-row: initial;', '0px', Breakpoints.lx)}
	}
	&:nth-child(3) {
		grid-column: span 2;
		justify-self: center;
		width: 592px;
		${mediaOnly('grid-column: initial; width: 100%;', '0px', Breakpoints.lx)}
	}
`

export const Header = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 24px;
	align-items: start;
	${media('flex-direction: row; align-items: center;', Breakpoints.xl)};
`

export const Subtitle = styled.p`
	color: ${themeObject.colors.grey[700]};
	${textModels('notAdaptive', 'xl', '400')};
`

export const ElementTitle = styled.p`
	color: ${themeObject.colors.grey[700]};
	${textModels('notAdaptive', 'xl', '600')};
	margin-bottom: 4px;
	white-space: pre-line;
`

export const ElementSubtitle = styled.p`
	color: ${themeObject.colors.grey[700]};
	${textModels('notAdaptive', 'm', '400')};
	&:not(&:last-child) {
		padding-bottom: 16px;
		margin-bottom: 16px;
		border-bottom: 1px solid ${themeObject.colors.grey[200]};
	}
`
